import homeReducer from './home';

export default {
    homeReducer,
};
